import { useMemo } from 'react';

import { useAuth } from '@/hooks/useAuth';

import { PermissionContext } from './permission-context';

/**
 * Derives role and permission checks from the authenticated user. The backend
 * sends the effective permission list, so the UI and the API agree.
 * Must be rendered inside AuthProvider.
 */
export function PermissionProvider({ children }) {
  const { user } = useAuth();

  const value = useMemo(() => {
    const permissions = new Set(user?.permissions ?? []);
    const role = user?.role ?? null;
    const companyRole = user?.company?.role ?? null;

    return {
      role,
      companyRole,
      permissions,
      can: (permission) => permissions.has(permission),
      hasRole: (...roles) => role !== null && roles.includes(role),
      hasCompanyRole: (...roles) => companyRole !== null && roles.includes(companyRole),
    };
  }, [user]);

  return <PermissionContext.Provider value={value}>{children}</PermissionContext.Provider>;
}
